import { httpServer as http } from "@/lib/axios";

const reward = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    // 奖励金汇总统计-列表
    async queryKaStat({ rootState }, params = {}) {
      const data = await http(
        "/reward/store-bonus-monthly/kastat/query",
        params
      );
      return data ? data.data || [] : { list: [], total: 0 };
    },
    // 奖励金汇总统计-导出
    async exportKaStat({ rootState }, params = {}) {
      await http("/reward/store-bonus-monthly/kastat/export", params);
    },
    // 奖励金明细统计-列表
    async queryKaFlow({ rootState }, params = {}) {
      const data = await http(
        "/reward/store-bonus-monthly/kaflow/query",
        params
      );
      return data ? data.data || [] : { list: [], total: 0 };
    },
    // 奖励金明细统计-导出
    async exportKaFlow({ rootState }, params = {}) {
      await http("/reward/store-bonus-monthly/kaflow/export", params);
    },
    // 奖励金明细统计-更新时间123
    async getFlowDate({ rootState }, params = {}) {
      const data = await http(
        "/reward/store-bonus-monthly/getFlowDate",
        params,
        { errorMessage: true },
        "get"
      );
      return data ? data.data : {};
    }
  },
  mutations: {}
};

export default reward;
